import React from 'react';
import { FadeIn } from './FadeIn';
import { Shield, Lock, CreditCard, Zap } from 'lucide-react';
export function FinalCTA() {
  return <section className="py-14 px-4 max-w-4xl mx-auto text-center pt-[0px] pb-[0px]" data-id="element-130">
      <FadeIn data-id="element-131">
        <div className="bg-[#020617] rounded-[2.5rem] p-8 md:p-16 border border-[#22c55e]/30 shadow-[0_20px_50px_rgba(2,6,23,0.15)] relative overflow-hidden" data-id="element-132">
          <div className="absolute inset-0 opacity-[0.05] bg-[radial-gradient(#22c55e_1px,transparent_1px)] [background-size:20px_20px]" data-id="element-133"></div>

          <div className="relative z-10" data-id="element-134">
            <h2 className="md:text-5xl font-black mb-10 text-transparent bg-clip-text bg-gradient-to-r from-white to-[#e2e8f0] text-[28px]" data-id="element-135">
              La próxima salida puede ser diferente. 🏃
            </h2>

            <div className="space-y-6 max-w-2xl mx-auto mb-10" data-id="element-136">
              {/* Option 1 */}
              <a href="https://tumanualdigital.com/cart/44204643352612:1" className="flex flex-col sm:flex-row items-center justify-between p-6 bg-[#0f172a] border border-[#22c55e]/30 rounded-2xl hover:border-[#22c55e] transition-colors group pt-[0px] pb-[0px]" data-id="element-137">
                <div className="text-left mb-4 sm:mb-0" data-id="element-138">
                  <h3 className="font-bold text-xl text-white flex items-center gap-2" data-id="element-139">
                    <span data-id="element-140">📘</span> SISTEMA RUNNING PRO
                  </h3>
                  <div className="flex items-center gap-3 mt-1" data-id="element-141">
                    <span className="text-[#ef4444] line-through text-sm font-bold" data-id="element-142">
                      $180.000
                    </span>
                    <span className="text-2xl font-black text-white" data-id="element-143">
                      $19.990 ARS
                    </span>
                  </div>
                </div>
                <div className="bg-[#1e293b] text-[#22c55e] font-black py-3 px-6 rounded-xl group-hover:bg-[#334155] transition-colors w-full sm:w-auto text-center border border-[#22c55e]/30" data-id="element-144">
                  → QUIERO MI SISTEMA RUNNING PRO
                </div>
              </a>

              {/* Option 2 */}
              <a href="https://tumanualdigital.com/cart/44204652527652:1" className="flex flex-col sm:flex-row items-center justify-between p-6 bg-gradient-to-r from-[#22c55e]/20 to-[#0f172a] border-2 border-[#22c55e] rounded-2xl hover:shadow-[0_0_30px_rgba(34,197,94,0.3)] transition-all group relative overflow-hidden" data-id="element-145">
                <div className="absolute top-0 right-0 bg-[#22c55e] text-[#020617] text-xs font-black px-3 py-1 rounded-bl-lg" data-id="element-146">
                  ⭐ MÁS ELEGIDO
                </div>
                <div className="text-left mb-4 sm:mb-0 mt-2 sm:mt-0" data-id="element-147">
                  <h3 className="font-bold text-xl text-white flex items-center gap-2" data-id="element-148">
                    <span data-id="element-149">🏆</span> SISTEMA RUNNING PRO + PROTOCOLO 90 DÍAS
                  </h3>
                  <div className="flex items-center gap-3 mt-1" data-id="element-150">
                    <span className="text-[#ef4444] line-through text-sm font-bold" data-id="element-151">
                      $220.000
                    </span>
                    <span className="text-2xl font-black text-[#22c55e]" data-id="element-152">
                      $27.990 ARS
                    </span>
                  </div>
                </div>
                <div className="bg-[#22c55e] text-[#020617] font-black py-3 px-6 rounded-xl group-hover:bg-[#4ade80] transition-colors w-full sm:w-auto text-center shadow-lg" data-id="element-153">
                  → QUIERO EL SISTEMA + PROTOCOLO 90 DÍAS
                </div>
              </a>
            </div>

            <div className="flex flex-wrap justify-center gap-x-6 gap-y-3 text-sm text-[#e2e8f0] font-bold" data-id="element-154">
              <span className="flex items-center gap-1.5" data-id="element-155">
                <Lock size={16} className="text-[#22c55e]" data-id="element-156" /> Pago seguro
              </span>
              <span className="flex items-center gap-1.5" data-id="element-157">
                <Zap size={16} className="text-[#22c55e]" data-id="element-158" /> Acceso en 5 min
              </span>
              <span className="flex items-center gap-1.5" data-id="element-159">
                <Shield size={16} className="text-[#22c55e]" data-id="element-160" /> Garantía 7 días
              </span>
            </div>
            <div className="flex flex-wrap justify-center gap-x-4 mt-4 text-sm text-[#475569] font-medium" data-id="element-161">
              <span className="flex items-center gap-1.5" data-id="element-162">
                <CreditCard size={16} data-id="element-163" /> Mercado Pago · Tarjeta · Transferencia
              </span>
            </div>
          </div>
        </div>
      </FadeIn>
    </section>;
}